<script setup lang="ts">
defineProps({
  percentage: {
    type: Number,
    required: true
  },
  color: {
    type: String,
    default: 'green'
  },
  height: {
    type: Number,
    default: 4
  },
  text: {
    type: String,
    default: ''
  },
  subtext: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <!-- Outer container -->
  <div :class="`w-full rounded bg-slate-700 relative flex items-center justify-center px-2 text-slate-300 ${subtext ? 'group cursor-pointer' : ''}`" :style="{ minHeight: Math.max(height, 20) + 'px' }">
    <!-- Inner progress bar -->
    <div
      :class="`absolute inset-0 rounded bg-${color}-600`"
      :style="{
        width: Math.min(percentage, 100) + '%'
      }"
    >
    </div>
    
    <!-- Text container on top of progress bar -->
    <div v-if="text || subtext" class="flex justify-between items-center w-full text-xs relative z-10">
      <!-- Main text - visible by default, hidden on hover only if subtext exists -->
      <span v-if="text" :class="subtext ? 'group-hover:hidden' : ''">{{ text }}</span>
      <!-- Subtext - hidden by default, visible on hover -->
      <span v-if="subtext" class="hidden group-hover:block">{{ subtext }}</span>
    </div>
  </div>
</template>
